'use client';

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  return (
    <html data-component-id="src\app\error.tsx:11:4" data-component-path="src\app\error.tsx" data-component-line="11" data-component-end-line="15" data-component-file="error.tsx" data-component-name="html" data-component-content="%7B%22elementName%22%3A%22html%22%7D">
      <body data-component-id="src\app\error.tsx:12:6" data-component-path="src\app\error.tsx" data-component-line="12" data-component-end-line="14" data-component-file="error.tsx" data-component-name="body" data-component-content="%7B%22elementName%22%3A%22body%22%7D">
        <h1 data-component-id="src\app\error.tsx:13:8" data-component-path="src\app\error.tsx" data-component-line="13" data-component-end-line="13" data-component-file="error.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22textContent%22%3A%22Something%20went%20wrong%22%7D">Something went wrong</h1>
      </body>
    </html>
  );
}
